import { useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";
import CardHeaderCommon from "../../../../../CommonElements/CardHeaderCommon/CardHeaderCommon";
import { ClipboardOnTextAreas, Copy, Cut, CutCopyFromTextarea } from "../../../../../utils/Constant";

const ClipboardOnTextarea = () => {
  const clipBoardTextParagraph: string = "A web designer must always enhance their work since creating websites is a creative effort. Therefore, a web designer must be more imaginative to produce exceptional results. Blogs about web design assist web designers in learning about new technologies, offer lessons, news, direction for a freebie, and much more. These blogs allow web designers to stay creative and improve their abilities. Therefore, advice from web design blogs is required to improve your business.";
  const [clipBoardValues, setClipBoardValues] = useState(clipBoardTextParagraph);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(clipBoardValues);
    setClipBoardValues(clipBoardValues);
  };

  const handleCut = async () => {
    await navigator.clipboard.writeText(clipBoardValues);
    setClipBoardValues("");
  };
  return (
    <Col sm="12" md="6">
      <Card>
        <CardHeaderCommon title={ClipboardOnTextAreas} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="card-description">{CutCopyFromTextarea}</P>
            <Input type="textarea" rows={1} spellCheck="false" value={clipBoardValues} onChange={({ target: { value } }) => setClipBoardValues(value)} />
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard me-2" color="warning" onClick={handleCopy}>
                <i className="fa fa-copy"></i>
                {Copy}
              </Btn>
              <Btn className="btn-clipboard-cut" color="success" onClick={handleCut}>
                <i className="fa fa-cut"></i>
                {Cut}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ClipboardOnTextarea;
